var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var colors = {
    tangerine: "#F05929",
    coral: "#C83E2B",
    coralLight: "#f0592926",
    forest: "#00652E",
    emerald: "#00AD46",
    gold: "#EB902B",
    yellow: "#FFB727",
    blood: "#C10222",
    rouge: "#EA3D35",
    white: "#FFFFFF",
    silver: "#F8F6F7",
    coolGray: "#E6E6E6",
    fog: "#B3B3B3",
    smoke: "#666666",
    fakeBlack: "#414042",
    pianoBlack: "#000000",
    peach: "#FABDA7",
    tea: "#8ECDA4",
    sunshine: "#FFD9A1",
    gradient: "linear-gradient(308.6deg, #F06531 -7.94%, #EA3D35 79.38%);",
    gradient2: "linear-gradient(308.6deg, #C10222 -7.94%, #F2473F 79.38%);",
    skeleton: "linear-gradient(308.6deg, #ED6400 -7.94%, #F2473F 79.38%)",
};
export var shadow = {
    superior: "0.5rem 0.5rem 2rem 0 rgba(37, 37, 39, .25)",
    intermediary: "0 0 2.43rem 0 rgba(166, 171, 189, 0.25)",
};
var semanticColors = {
    primary: colors.tangerine,
    secondary: colors.coral,
    primarySuccess: colors.forest,
    successTag: colors.emerald,
    primaryWarning: colors.gold,
    warningTag: colors.yellow,
    primaryDanger: colors.gold,
    dangerTag: colors.blood,
    gradient: colors.rouge,
};
export var color = __assign(__assign({}, semanticColors), colors);
